import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const RefreshGlyph = /*#__PURE__*/createElement("g", {
  id: "refresh"
}, /*#__PURE__*/createElement("polygon", {
  points: "53.7,20.7 40.5,7.5 40.5,33.8"
}), /*#__PURE__*/createElement("path", {
  d: "M42.5,72.5c-14.9,0-27-12.1-27-27s12.1-27,27-27c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5c-13.2,0-24,10.8-24,24 s10.8,24,24,24s24-10.8,24-24c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5C69.5,60.4,57.4,72.5,42.5,72.5z"
}));
const Refresh = createSvg({
  name: 'refresh',
  path: RefreshGlyph
});

export default Refresh;
export { RefreshGlyph };
